export function showSectionHeader(
  sections: any,
  sectionKey: string,
  viewModel: any
) {
  // Check if section exists and has fields
  if (!sections[sectionKey] || !sections[sectionKey].fields) {
    return false;
  }
  
  // Check if any field in the section should be visible
  return sections[sectionKey].fields.some(
    (current: any) => viewModel[current.id] === true
  );
}
